import React from 'react';
import { useNavigate } from 'react-router-dom';
import Menubar from './Menubar/page';

const PCLayout = ({ isDarkMode, toggleTheme, activePage, contentRef, onMenuItemClick, children }) => {
    const navigate = useNavigate();

    // Default handleMenuItemClick if one is not provided
    const defaultHandleMenuItemClick = (sectionId) => {
        const aboutMeSections = ['me', 'education', 'hobbies'];
        const professionalSections = ['experience', 'research', 'skills', 'more'];
        const miscSections = ['accolades', 'projects', 'blog'];

        if (aboutMeSections.includes(sectionId.toLowerCase())) {
            navigate('/', { state: { targetSection: sectionId.toLowerCase() } });
            return;
        }

        if (professionalSections.includes(sectionId.toLowerCase())) {
            navigate('/prof', { state: { targetSection: sectionId.toLowerCase() } });
            return;
        }

        if (miscSections.includes(sectionId.toLowerCase())) {
            navigate('/misc', { state: { targetSection: sectionId.toLowerCase() } });
            return;
        }
    };

    const handleMenuClick = onMenuItemClick || defaultHandleMenuItemClick;

    return (
        <>
            {/* Decorative top-right element */}
            <div className="PCdesignElement transition-effect">
                Thnx to Dhimom &lt;3 for design idea!
            </div>

            {/* Menu bar */}
            <div className="PCmenuBar transition-effect">
                <Menubar
                    isDarkMode={isDarkMode}
                    activePage={activePage}
                    onMenuItemClick={handleMenuClick}
                />
            </div>

            <div className="PCcontentArea transition-effect">
                <div className="PCcontentHeader">
                    <div className="PCsocialIcons transition-effect">
                        <a href="https://www.linkedin.com/in/avilol" target="_blank" rel="noopener noreferrer">
                            <img
                                src={`/images/siteElements/contentHeader/${isDarkMode ? 'black' : 'white'}_linkedin.png`}
                                className="PCsocialIcon transition-effect"
                                alt="LinkedIn" />
                        </a>
                        <a href="https://github.com/avi1o1" target="_blank" rel="noopener noreferrer">
                            <img
                                src={`/images/siteElements/contentHeader/${isDarkMode ? 'black' : 'white'}_github.png`}
                                className="PCsocialIcon transition-effect"
                                alt="GitHub" />
                        </a>
                        <a href="mailto:aviral.gupta@research.iiit.ac.in" target="_blank" rel="noopener noreferrer">
                            <img
                                src={`/images/siteElements/contentHeader/${isDarkMode ? 'black' : 'white'}_mail.png`}
                                className="PCsocialIcon transition-effect"
                                alt="Email" />
                        </a>
                    </div>
                    <div className="PCthemeIcon transition-effect">
                        {isDarkMode ? (
                            <img
                                onClick={toggleTheme}
                                className="PCtoggleTheme transition-effect"
                                src="/images/siteElements/contentHeader/sun.png"
                                alt="Light Mode" />
                        ) : (
                            <img
                                onClick={toggleTheme}
                                className="PCtoggleTheme transition-effect"
                                src="/images/siteElements/contentHeader/moon.png"
                                alt="Dark Mode" />
                        )}
                    </div>
                </div>

                <div className="PCcontentMain" ref={contentRef}>
                    {children}
                </div>
            </div>

            {/* Download Resume button with download functionality */}
            <a
                href="/AviResume.pdf"
                download="AviResume.pdf"
                className="PCresume transition-effect"
            >
                Download Résumé
            </a>
        </>
    );
};

export default PCLayout;
